module.exports = __webpack_public_path__ + "static/media/Programci2.e967abf5.png";